<template>
  <el-container class="footer-menu">
    <div class="bg">
      <ul class="first-menu">
        <li v-for="(items,index) in menuList" :key="index">
          {{items}}
          <ul class="second-ul">
            <li
              v-for="(items,idx) in menuChildList[index]"
              :key="idx"
              @click="handlelink(items)"
            >{{items}}</li>
          </ul>
        </li>
      </ul>
   <ul class="download1">
        <li>
          奥信汽车</li>
        <li>
          <img src="../assets/img/奥信汽车.png" />
        </li>
      </ul>

      <ul class="download2">
        <li>奥信汽车经销商版</li>
        <li>
          <img src="../assets/img/奥信汽车经销商版.png" />
        </li>
      </ul>
      
    </div>
  
    <div class="footer-bottom">
       <span>京ICP备2022024656号-2</span>
      <span>版权所有：北京奥信汽车服务有限公司</span>
    </div>
  </el-container>
</template>

<script>
export default {
  name: "footerCom",
  data() {
    return {
      menuList: ["关于我们", "帮助中心", "联系我们"],
      menuChildList: {
        /* 0: ["公司介绍", "企业文化", "高管介绍", "发展历程"],  */
        0: ["企业文化"],
        1: ["法律法规"],
        2: [
          "地址：北京市平谷区马坊镇金河北街18号院5号楼3层303",
        ],
      },
    };
  },
  components: {},

  computed: {},
  created() {},
  methods: {
    handle(index) {
      this.activeClass = index;
    },
    toUrl() {
      window.open("https://beian.miit.gov.cn/#/Integrated/recordQuery");
    },
    toUrl2() {
      window.open("https://beian.miit.gov.cn/#/Integrated/recordQuery")
    },
    handlelink(data) {
      if (data == "法律法规" || data == "监管政策" || data == "常见问题") {
        this.$router.push({ path: "/help", query: { id: data } });
      } else if (data == "福保动态" || data == "行业动态") {
        this.$router.push({ path: "/news", query: { id: data } });
      } else if (
        data == "公司介绍" ||
        data == "企业文化" ||
        data == "高管介绍" ||
        data == "发展历程"
      ) {
        this.$router.push({ path: "/aboutUs", query: { id: data } });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-menu {
  height: 340px !important;
  background-color: $gary;
  display: flex;
  flex-wrap: wrap;
  .bg {
    width: 100%;
    min-width: 970px;
    box-sizing: border-box;
    height: 200px;
    display: flex;
    margin: 40px 15% 0 15%;
    .first-menu {
      &:first-child li {
        cursor: default;
      }
    }
  }
}
ul {
  list-style-type: none;
  margin: 0px;
  padding: 0px;
  text-align: left;
  width: 730px;
  height: 200px;
  .second-ul {
    width: 80px;
    margin-top: 30px;
    li {
      color: $font-color-black;
      font-size: $font-size-lv5;
      width: 80px;
      margin-bottom: 16px;
      cursor: pointer !important;
      &:nth-last-child(2) {
        width: 250px;
      }
      &:last-child {
        width: 146px;
      }
    }
  }
}
li {
  color: $font-color-main;
  font-size: 18px;
  float: left;
  margin-right: 80px;
  font-family: "Microsoft YaHei Bold";
  font-weight: 500;
  cursor: pointer;
}
.attention {
  height: 200px;
  width: 200px;
  margin-left: 130px;
  li {
    cursor: default !important;
  }
  li:last-child {
    margin-top: 20px;
  }
}
.download1 {
  height: 200px;
  width: 200px;
  
  li {
    cursor: default !important;
   
  }
  li:last-child {
    margin-top: 20px;
    
  }
   img {
    width: 150px;
   
    
  }
}
.download2 {
  height: 200px;
  width: 300px;
  margin-left: 50px;

  li {
    cursor: default !important;
    margin-left: 10px;
  }
  li:last-child {
    margin-top: 20px;
    height: 150px;
    width: 150px;
    background: rgba(255, 255, 255, 0.598);
  }
  img {
    width: 130px;
    margin-left: 10px;
    margin-top: 10px;
  }
}
.footer-bottom {
  color: $font-color-gary1;
  font-size: 12px;
  // margin: 30px 0 40px 300px;
  text-align: center;
  width: 100%;
  span {
    margin-right: 30px;
  }
  img {
    width: 12px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue